export const langaugeCode = {
    "English" : "en",
    "हिंदी" : "hi",
    "ଓଡ଼ିଆ" : "or",
    "मराठी" : "mr"
}

export const languageLabel = {
    "en" : "English",
    "hi" : "हिंदी",
    "or" : "ଓଡ଼ିଆ",
    "mr" : "मराठी"
}

export const fontSizeLabel = {
    "en": "A",
    "hi": "आ",
    "or": "A",
    "mr" : "A"
}
export const languageCheckSuccessMessage = {
    "en" : " Successfully Logged In",
    "hi" : "लॉग इन सफल रहा",
    "or" : "ଲଗଇନ୍ ସଫଳ ହେଲା",
    "mr" : "यशस्वीपणे लॉग इन झाले"
}
export const languageCheckWelcomeMessage = {
    "en" : "Welcome",
    "hi" : "स्वागत है,",
    "or" : "ସ୍ୱାଗତ,",
    "mr" : "स्वागत आहे,"
}
export const languagecheckHeading = {
    "en" : "Select Language",
    "hi" : "भाषा चुनें",
    "or": "ଭାଷା ଚୟନ କରନ୍ତୁ",
    "mr" : "भाषा निवडा"
}
export const languagecheckSubHeading = {
    "en" : "Healthvaani is available in these languages",
    "hi" : "हेल्थवाणी इन भाषाओं में उपलब्ध है",
    "or": "Healthvaani ଏହି ଭାଷାଗୁଡିକରେ ଉପଲବ୍ଧ ଅଛି",
    "mr" : "हेल्थवाणी खालील भाषांमध्ये उपलब्ध आहे"
}
export const languagecheckNextButton = {
    "en" : "Start Asking Questions",
    "hi" : "प्रश्न पूछना शुरू करें",
    "or" : "ପ୍ରଶ୍ନ ପଚାରିବା ଆରମ୍ଭ କରନ୍ତୁ",
    "mr" : "प्रश्न विचारायला सुरुवात करा"
}
export const LanguageName = {
    en: "English",
    hi: "हिंदी",
    or: "ଓଡ଼ିଆ",
    bn: "Bengali",
    ta: "Tamil",
    te: "Telugu",
    mr: "मराठी",
    gu: "Gujarati",
    pa: "Punjabi",
    ml: "Malayam",
    ka: "Kannada",
    ur: "Urdu",
  };